import React from 'react';
import { SECTION_BLOG_PAGE } from '@wix/communities-blog-client-common';
import Link from '../../../common/components/link/internal-link';
import styles from './link-list.scss';

type LinkListProps = {
  links?: {
    key: string;
    path: string;
    text: React.JSX.Element;
  }[];
  emptyState?: string;
  sectionId?: string;
  error?: boolean;
};

const LinkList: React.FC<LinkListProps> = ({
  links = [],
  emptyState,
  sectionId = SECTION_BLOG_PAGE,
  error,
}) => {
  return links.length ? (
    <ul data-hook="link-list" className={styles.root}>
      {links.map(({ key, path, text }) => (
        <li data-hook="link-list-item" key={key} className={styles.item}>
          <Link to={path} sectionId={sectionId} addHoverClasses={false} className={styles.link}>
            <span className={styles.ellipsis}>{text}</span>
          </Link>
        </li>
      ))}
    </ul>
  ) : (
    <div className={styles.rootWithEmptyMessage}>
      <span className={error ? undefined : styles.ellipsis}>{emptyState}</span>
    </div>
  );
};

export default LinkList;
